// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var DOM__Event$SmartcutsMacros = require("../DOM__Event.bs.js");
var ModifierKeys$SmartcutsMacros = require("./shared/ModifierKeys.bs.js");
var ViewportPosition$SmartcutsMacros = require("./shared/ViewportPosition.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("../semantics/InnerTextSemantic.bs.js");
var SelectorOverrides$SmartcutsMacros = require("./shared/SelectorOverrides.bs.js");
var InnerTextSemanticFunctors$SmartcutsMacros = require("../semantics/InnerTextSemanticFunctors.bs.js");
var InnerTextSemanticAuthoringConfig$SmartcutsMacros = require("../semantics/InnerTextSemanticAuthoringConfig.bs.js");
var InnerTextSemanticParamDescriptor$SmartcutsMacros = require("../semantics/InnerTextSemanticParamDescriptor.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function eventSrc_encode(v) {
  switch (v) {
    case /* Mouseup */0 :
        return ["Mouseup"];
    case /* Click */1 :
        return ["Click"];
    case /* RecordClick */2 :
        return ["RecordClick"];
    
  }
}

function eventSrc_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Click" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Click */1
                  };
          }
      case "Mouseup" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Mouseup */0
                  };
          }
      case "RecordClick" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RecordClick */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "domElementIdentifierWithSelector",
                DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
              ],
              [
                "modifierKeys",
                ModifierKeys$SmartcutsMacros.t_encode(v.modifierKeys)
              ],
              [
                "eventSrc",
                eventSrc_encode(v.eventSrc)
              ],
              [
                "clickCount",
                Decco.intToJson(v.clickCount)
              ],
              [
                "viewportPosition",
                ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
  if (domElementIdentifierWithSelector.TAG === /* Ok */0) {
    var modifierKeys = ModifierKeys$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "modifierKeys"), null));
    if (modifierKeys.TAG === /* Ok */0) {
      var eventSrc = eventSrc_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
      if (eventSrc.TAG === /* Ok */0) {
        var clickCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickCount"), null));
        if (clickCount.TAG === /* Ok */0) {
          var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
          if (viewportPosition.TAG === /* Ok */0) {
            var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
            if (positionRelToElement.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                        modifierKeys: modifierKeys._0,
                        eventSrc: eventSrc._0,
                        clickCount: clickCount._0,
                        viewportPosition: viewportPosition._0,
                        positionRelToElement: positionRelToElement._0
                      }
                    };
            }
            var e = positionRelToElement._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".positionRelToElement" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = viewportPosition._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".viewportPosition" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = clickCount._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".clickCount" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = eventSrc._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".eventSrc" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = modifierKeys._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".modifierKeys" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = domElementIdentifierWithSelector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementIdentifierWithSelector" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function stringify(param) {
  var tmp;
  switch (param.eventSrc) {
    case /* Mouseup */0 :
        tmp = "Mouseup";
        break;
    case /* Click */1 :
        tmp = "Click";
        break;
    case /* RecordClick */2 :
        tmp = "RecordClick";
        break;
    
  }
  return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + (", modifierKeys: " + (ModifierKeys$SmartcutsMacros.stringify(param.modifierKeys) + (", eventSrc: " + (tmp + (", clickCount: " + (String(param.clickCount) + ", viewportPosition(x, y))")))))));
}

var Recording = {
  eventSrc_encode: eventSrc_encode,
  eventSrc_decode: eventSrc_decode,
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "modifierKeys",
                ModifierKeys$SmartcutsMacros.t_encode(v.modifierKeys)
              ],
              [
                "clickCount",
                Decco.intToJson(v.clickCount)
              ],
              [
                "viewportPosition",
                ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
              ],
              [
                "maybeSelectorOverrides",
                Decco.optionToJson(SelectorOverrides$SmartcutsMacros.t_encode, v.maybeSelectorOverrides)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var modifierKeys = ModifierKeys$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "modifierKeys"), null));
    if (modifierKeys.TAG === /* Ok */0) {
      var clickCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickCount"), null));
      if (clickCount.TAG === /* Ok */0) {
        var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
        if (viewportPosition.TAG === /* Ok */0) {
          var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
          if (positionRelToElement.TAG === /* Ok */0) {
            var maybeSelectorOverrides = Decco.optionFromJson(SelectorOverrides$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeSelectorOverrides"), null));
            if (maybeSelectorOverrides.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        selector: selector._0,
                        modifierKeys: modifierKeys._0,
                        clickCount: clickCount._0,
                        viewportPosition: viewportPosition._0,
                        positionRelToElement: positionRelToElement._0,
                        maybeSelectorOverrides: maybeSelectorOverrides._0
                      }
                    };
            }
            var e = maybeSelectorOverrides._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".maybeSelectorOverrides" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = positionRelToElement._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".positionRelToElement" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = viewportPosition._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".viewportPosition" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = clickCount._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".clickCount" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = modifierKeys._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".modifierKeys" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function fromRecordingCommandValue(param) {
  return {
          selector: param.domElementIdentifierWithSelector.selector,
          modifierKeys: param.modifierKeys,
          clickCount: param.clickCount,
          viewportPosition: param.viewportPosition,
          positionRelToElement: param.positionRelToElement,
          maybeSelectorOverrides: undefined
        };
}

function updateSelector(f, v) {
  return {
          selector: Curry._1(f, v.selector),
          modifierKeys: v.modifierKeys,
          clickCount: v.clickCount,
          viewportPosition: v.viewportPosition,
          positionRelToElement: v.positionRelToElement,
          maybeSelectorOverrides: v.maybeSelectorOverrides
        };
}

function getInputIdentifier(param) {
  return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}

function stringify$1(param) {
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", modifierKeys: " + (ModifierKeys$SmartcutsMacros.stringify(param.modifierKeys) + (", clickCount: " + (String(param.clickCount) + (", maybeSelectorOverrides: " + (Belt_Option.getWithDefault(Belt_Option.map(param.maybeSelectorOverrides, SelectorOverrides$SmartcutsMacros.stringify), "undefined") + ", viewportPosition(x, y), positionRelToElement)")))))));
}

var Authoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromRecordingCommandValue: fromRecordingCommandValue,
  updateSelector: updateSelector,
  getInputIdentifier: getInputIdentifier,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "semantic",
                InnerTextSemantic$SmartcutsMacros.t_encode(v.semantic)
              ],
              [
                "modifierKeys",
                ModifierKeys$SmartcutsMacros.t_encode(v.modifierKeys)
              ],
              [
                "clickCount",
                Decco.intToJson(v.clickCount)
              ],
              [
                "viewportPosition",
                ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
              ],
              [
                "maybeSelectorOverrides",
                Decco.optionToJson(SelectorOverrides$SmartcutsMacros.t_encode, v.maybeSelectorOverrides)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var semantic = InnerTextSemantic$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
    if (semantic.TAG === /* Ok */0) {
      var modifierKeys = ModifierKeys$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "modifierKeys"), null));
      if (modifierKeys.TAG === /* Ok */0) {
        var clickCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickCount"), null));
        if (clickCount.TAG === /* Ok */0) {
          var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
          if (viewportPosition.TAG === /* Ok */0) {
            var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
            if (positionRelToElement.TAG === /* Ok */0) {
              var maybeSelectorOverrides = Decco.optionFromJson(SelectorOverrides$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeSelectorOverrides"), null));
              if (maybeSelectorOverrides.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          selector: selector._0,
                          semantic: semantic._0,
                          modifierKeys: modifierKeys._0,
                          clickCount: clickCount._0,
                          viewportPosition: viewportPosition._0,
                          positionRelToElement: positionRelToElement._0,
                          maybeSelectorOverrides: maybeSelectorOverrides._0
                        }
                      };
              }
              var e = maybeSelectorOverrides._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".maybeSelectorOverrides" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = positionRelToElement._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".positionRelToElement" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = viewportPosition._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".viewportPosition" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = clickCount._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".clickCount" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = modifierKeys._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".modifierKeys" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = semantic._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".semantic" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function stringify$2(param) {
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", maybeSelectorOverrides: " + (Belt_Option.getWithDefault(Belt_Option.map(param.maybeSelectorOverrides, SelectorOverrides$SmartcutsMacros.stringify), "undefined") + (", modifierKeys: " + (ModifierKeys$SmartcutsMacros.stringify(param.modifierKeys) + (", clickCount: " + (String(param.clickCount) + (", viewportPosition(x, y), positionRelToElement, semantic=" + (InnerTextSemantic$SmartcutsMacros.stringify(param.semantic) + ")")))))))));
}

function selectorGet(param) {
  return [param.selector];
}

function updateSelector$1(f, v) {
  return {
          selector: Curry._1(f, v.selector),
          semantic: v.semantic,
          modifierKeys: v.modifierKeys,
          clickCount: v.clickCount,
          viewportPosition: v.viewportPosition,
          positionRelToElement: v.positionRelToElement,
          maybeSelectorOverrides: v.maybeSelectorOverrides
        };
}

var Playback = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2,
  selectorGet: selectorGet,
  updateSelector: updateSelector$1
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function getSelector(param) {
  return param.selector;
}

var partial_arg = {
  getSelector: getSelector
};

var partial_arg$1 = InnerTextSemanticAuthoringConfig$SmartcutsMacros.MakeTransformers;

function fromAuthoringCommandValueAndSemantic(commandValue, semantic) {
  return {
          selector: commandValue.selector,
          semantic: semantic,
          modifierKeys: commandValue.modifierKeys,
          clickCount: commandValue.clickCount,
          viewportPosition: commandValue.viewportPosition,
          positionRelToElement: commandValue.positionRelToElement,
          maybeSelectorOverrides: commandValue.maybeSelectorOverrides
        };
}

var include = (function (param) {
      return partial_arg$1(partial_arg, param);
    })({
      fromAuthoringCommandValueAndSemantic: fromAuthoringCommandValueAndSemantic
    });

var AuthoringConfig = include;

var partial_arg$2 = InnerTextSemanticParamDescriptor$SmartcutsMacros;

var partial_arg$3 = InnerTextSemanticFunctors$SmartcutsMacros.MakePlaybackParamValue;

var PlaybackParamValue = (function (param) {
      return partial_arg$3(partial_arg$2, param);
    })({
      updateSelector: updateSelector$1
    });

var ParamDescriptor;

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* include Not a pure module */
